// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { GET_USER_ALL_LEAGUES, getUserAllLeagues } from 'src/redux/actions/leagues/leagues'
import http from 'src/services/http'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetUserAllLeagues(): Generator<IOEffect, void, any> {
  while (true) {
    const action = yield take(GET_USER_ALL_LEAGUES.REQUEST)

    try {
      const { userId, limit, offset } = action.payload
      const { data } = yield call(http, `admin/user/${userId}/leagues`, {
        method: 'GET',
        params: {
          limit,
          offset,
        },
      })

      yield put(getUserAllLeagues.success(data))
    } catch (e) {
      yield put(getUserAllLeagues.error(e.message))
    }
  }
}

export default [fork(watchGetUserAllLeagues)]
